import * as React from 'react';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { ActiveIngredientAdminModel } from "../../../models/activeIngredient";
import { Editor } from 'primereact/editor';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { AgeGroup, RoaTypeAbbr, Lang } from '../../../common/enums';
import { DosageLevelModel } from "../../../models/dosage";
import { DiseaseAdminModel } from "../../../models/disease";
import { DosageLevelContentModel } from '../../../models/dosage/dosageLevelContentModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';

interface IProps {
  activeIngredient: ActiveIngredientAdminModel,
  handleDosageContentChange: any,
  removeDosageLevelClick: any,
  setIsVisibleDosageLevelAddEditDialog: any,
  onAddEditDosageLevelClick: any,
  getContentValue: any
}

interface IState {
  validationMessage: string,
  currentTempId: number
}

class ActiveIngredientTabDosage extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      validationMessage: '',
      currentTempId: 0
    };
  }

  isValidAddEditForm() {
    let message = '';
    this.setState({
      validationMessage: ''
    });
    if ((!this.props.activeIngredient.activeIngredientName || this.props.activeIngredient.activeIngredientName.trim() == '')) {
      message += "Please enter 'Name'.<br />";
    }
    this.setState({
      validationMessage: message
    });
    return message == '';
  }

  handleDosageLevelAddEditClick = (dosageLevelId) => {
    if (!dosageLevelId) {
      let currentTempId = this.state.currentTempId - 1;
      let newDosageLevel = new DosageLevelModel();
      newDosageLevel.disease = new DiseaseAdminModel();
      newDosageLevel.dosageLevelId = currentTempId;

      let contentList = new Array<DosageLevelContentModel>(0);
      const langKeys = HelperFunctions.getEnumKeys(Lang);

      langKeys.map(k => {
        let content = new DosageLevelContentModel();
        content.langId = parseInt(Lang[k]);
        content.specificDescription = '';
        content.comments = '';
        content.uses = '';
        contentList.push(content);
      });

      this.setState({
        currentTempId: currentTempId
      });

      newDosageLevel.dosageLevelContent = contentList;

      this.setState({
        currentTempId: currentTempId
      });

      this.handleDosageLevelAddEditButton(newDosageLevel);
    } else {
      let currentDosageLevel = this.props.activeIngredient.dosageContent.dosageLevels.
        find(f => f.dosageLevelId === dosageLevelId);
      if (currentDosageLevel) {
        this.handleDosageLevelAddEditButton(currentDosageLevel);
      }
      else {
        this.setState({
          validationMessage: 'Eror'
        });
      }
    }
  }

  //TODO: common helper function for all enums with type of enum and id as params
  //TODO: add enum values to translate
  getAgeGroupName(id: number) {
    let enumElement = Object
      .keys(AgeGroup)
      .find(key => AgeGroup[key] === id);

    // return Translate(enumElement);
    return enumElement;
  }

  getRoaTypeName(id: number) {
    let enumElement = Object
      .keys(RoaTypeAbbr)
      .find(key => RoaTypeAbbr[key] === id);

    // return Translate(enumElement);
    return enumElement;
  }

  handleDosageLevelAddEditButton(currentDosageLevel: DosageLevelModel) {
    this.props.onAddEditDosageLevelClick(currentDosageLevel)
    this.props.setIsVisibleDosageLevelAddEditDialog(true);
  }

  public render() {

    //TODO: Move this logic into method
    const { activeIngredient } = this.props;
    const { dosageContent } = activeIngredient;
    const { dosageLevels } = activeIngredient.dosageContent;

    let dosgaeLevelsElement: any = null;
    if (dosageLevels && dosageLevels.length > 0) {
      dosgaeLevelsElement =
        <div className="p-col-12 p-md-12">
          <DataTable
            value={dosageLevels}
            dataKey='dosageLevelId'
          >
            <Column
              header="Age group"
              field="ageGroupId"
              body={(rowData, column) =>
                <div>
                  {this.getAgeGroupName(rowData.ageGroupId)}
                </div>}
            />
            <Column
              header="Disease"
              field="disease"
              body={(rowData, column) =>
                rowData && rowData.disease && rowData.disease.diseaseContent && rowData.disease.diseaseContent.length ?
                  rowData.disease.diseaseContent.map(r => r.diseaseName).join(' / ')
                  : null
              } />
            <Column
              header="RoA"
              field="roaTypeId"
              body={(rowData, column) =>
                <div>
                  {this.getRoaTypeName(rowData.roaTypeId)}
                </div>}
            />
            <Column
              header="Age range"
              field="ageRange"
            />
            <Column
              header="Weigh range"
              field="weightRange"
            />
            <Column
              header="Single dose"
              field="singleDose"
            />
            <Column
              header="Loading dose"
              field="loadingDose"
            />
            <Column
              header="Max daily dose"
              field="maxDailyDose"
            />
            <Column
              header="Frequency of intake"
              field="frequencyOfIntake"
            />
            <Column
              header="Intakes interval"
              field="minMaxTimeBetweenIntakes"
            />
            <Column
              header="Titration interval"
              field="minMaxTitration"
            />
            <Column
              header="Actions"
              style={{ textAlign: "center", width: "8em" }}
              body={(rowData, column) =>
                <div>
                  <Button
                    type="button"
                    icon="pi pi-pencil"
                    className="p-button-warning"
                    tooltip="Edit"
                    tooltipOptions={{ position: 'top' }}
                    style={{ marginRight: ".5em" }}
                    onClick={() => this.handleDosageLevelAddEditClick(rowData.dosageLevelId)}
                  />
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    className="p-button-danger"
                    tooltip="Remove"
                    tooltipOptions={{ position: 'top' }}
                    onClick={() => this.props.removeDosageLevelClick(rowData.dosageLevelId)}
                  />
                </div>
              }
            />
          </DataTable>
        </div>;
    } else {
      dosgaeLevelsElement = null;
    }

    return (
      <div style={{ minHeight: '550px' }}>
        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
        <div className="p-grid p-md-12">
          <div className="p-col-12 p-md-6">
            <label>Summary:</label>
            <Editor
              style={{ width: '100%', height: '120px' }}
              onTextChange={(e) => { this.props.handleDosageContentChange('summary', e.htmlValue) }}
              value={this.props.getContentValue('summary')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Overdose description:</label>
            <Editor
              style={{ width: '100%', height: '120px' }}
              onTextChange={(e) => { this.props.handleDosageContentChange('overdoseDescription', e.htmlValue) }}
              value={this.props.getContentValue('overdoseDescription')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Dose adjustments:</label>
            <Editor
              style={{ width: '100%', height: '120px' }}
              onTextChange={(e) => { this.props.handleDosageContentChange('doseAdjustments', e.htmlValue) }}
              value={this.props.getContentValue('doseAdjustments')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Precautions:</label>
            <Editor
              style={{ width: '100%', height: '120px' }}
              onTextChange={(e) => { this.props.handleDosageContentChange('precautions', e.htmlValue) }}
              value={this.props.getContentValue('precautions')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Other comments:</label>
            <Editor
              style={{ width: '100%', height: '120px' }}
              onTextChange={(e) => { this.props.handleDosageContentChange('otherComments', e.htmlValue) }}
              value={this.props.getContentValue('otherComments')}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Other information:</label>
            <Editor
              style={{ width: '100%', height: '120px' }}
              onTextChange={(e) => { this.props.handleDosageContentChange('otherInformation', e.htmlValue) }}
              value={this.props.getContentValue('summary')}
            />
          </div>
          <div className="p-col-12 p-md-12" style={{ marginTop: "20px" }}>
            <button
              onClick={() => this.handleDosageLevelAddEditClick(null)}
              className="btn btn-success"
              style={{ marginRight: "5px" }}>
              Add New Dosage Level
            </button>
          </div>
          <div>
            {dosgaeLevelsElement}
          </div>
        </div>
      </div>
    )
  }
}

export default ActiveIngredientTabDosage;